module.exports = __webpack_public_path__ + "img/dimensie-zingeving.03eeedba.svg";